/**
 * 定义接口
 * @author： xuyd
 * @date：2024-05-05
 */
import request from "@/utils/request.js"

import {context} from '@/config/env.js'
const serviceModule = context.sunflower

export default {

  /**
   * 获取所有知识库组
   */
  selectWikiGroupList: () => {
    return request.post(serviceModule + "/doc/wikigroup/select", {});
  },

  /**
   * 保存知识库组
   * @param params {JSON} {id, title}
   */
  saveWikiGroup: (params) => {
    return request.post(serviceModule + "/doc/wikigroup/save", params);
  },

  /**
   * 删除知识库组
   * @param id
   */
  deleteWikiGroup: (id) => {
    return request.post(serviceModule + "/doc/wikigroup/select?id=" + id);
  },

  /**
   * 查询知识库内容
   * @param id
   */
  getDocWiki: (id) => {
    return request.get(serviceModule + "/doc/wikidetail/get?id=" + id);
  },

  /**
   * 保存知识库内容
   * @param params
   */
  saveDocWiki: (params) => {
    return request.post(serviceModule + "/doc/wikidetail/save", params);
  },

  /**
   * 删除知识库内容
   * @param id
   */
  deleteDocWiki: (id) => {
    return request.post(serviceModule + "/doc/wikidetail/delete?id=" + id);
  },

}
